module.exports = __webpack_public_path__ + "img/20200514_152057.df598100.jpg";